import { render, staticRenderFns } from "./OrderCheckPass.vue?vue&type=template&id=4adead9e&"
import script from "./OrderCheckPass.vue?vue&type=script&lang=ts&"
export * from "./OrderCheckPass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports